import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { BareProgressBar } from "@faire/retailer-visitor-shared/components/BareProgressBar/BareProgressBar";
import { NUM_PRODUCTS_IOPTIONS } from "@faire/retailer-visitor-shared/consts/numProductsOptions";
import { SOURCE_OPTIONS } from "@faire/retailer-visitor-shared/consts/sourceOptions";
import { STOCKIST_IOPTIONS } from "@faire/retailer-visitor-shared/consts/stockistOptions";
import { INBOUND_BRAND_CATEGORY_OPTIONS } from "@faire/retailer-visitor-shared/features/MakerApplication/MakerApplicationCategories";
import { AcceptTermsCheckbox } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/BrandCreateAccount/AcceptTermsCheckbox";
import { AcceptTermsMessage } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/BrandCreateAccount/AcceptTermsMessage";
import { MAKER_SIGN_UP_BASED_IN_STORAGE_KEY } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/consts";
import { getLabels, HEAR_ABOUT_US_LABEL, NUMBER_OF_PRODUCTS_LABEL } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/MakerSignUp/consts";
import { MakerSignUpFooterWrapper } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/MakerSignUp/MakerSignUpFooterWrapper";
import { MakerSignUpWrapper } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/MakerSignUp/MakerSignUpWrapper";
import { useMakerSignUpFormFields } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/MakerSignUp/useMakerSignUpFormFields";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { LocalStorage } from "@faire/web--source/common/Storage";
import { Button } from "@faire/web--source/slate/Button";
import Checkbox from "@faire/web--source/slate/Checkbox";
import { Dropdown } from "@faire/web--source/slate/Dropdown";
import { CheckOutline } from "@faire/web--source/slate/icons/foundation/CheckOutline";
import { Information } from "@faire/web--source/slate/icons/Information";
import { FormInputLabel, Input } from "@faire/web--source/slate/Input";
import { Column, Grid, Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContent } from "@faire/web--source/ui/ResponsiveContent";
import brands from "@faire/web-api--source/routes/www/brands";
import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";
var NoWrapFormatting = function(chunk) {
    return /*#__PURE__*/ _jsx("div", {
        style: {
            whiteSpace: "nowrap",
            display: "inline-block"
        },
        children: chunk
    });
};
var MakerSignUpFormBase = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useMakerSignUpFormFields = useMakerSignUpFormFields(), companyName = _useMakerSignUpFormFields.companyName, countryLabel = _useMakerSignUpFormFields.countryLabel, countryDropdownOption = _useMakerSignUpFormFields.countryDropdownOption, setCountry = _useMakerSignUpFormFields.setCountry, url = _useMakerSignUpFormFields.url, email = _useMakerSignUpFormFields.email, categoryOption = _useMakerSignUpFormFields.categoryOption, stockists = _useMakerSignUpFormFields.stockists, numProducts = _useMakerSignUpFormFields.numProducts, displaySource = _useMakerSignUpFormFields.displaySource, onUrlBlur = _useMakerSignUpFormFields.onUrlBlur, errorFor = _useMakerSignUpFormFields.errorFor, urlValidationInProgress = _useMakerSignUpFormFields.urlValidationInProgress, isUrlValid = _useMakerSignUpFormFields.isUrlValid, onChange = _useMakerSignUpFormFields.onChange, onSubmit = _useMakerSignUpFormFields.onSubmit, onBackClick = _useMakerSignUpFormFields.onBackClick, brandNameEvent = _useMakerSignUpFormFields.brandNameEvent, acceptedTerms = _useMakerSignUpFormFields.acceptedTerms, toggleAcceptedTerms = _useMakerSignUpFormFields.toggleAcceptedTerms, shouldShowSMSOptIn = _useMakerSignUpFormFields.shouldShowSMSOptIn, emailEvent = _useMakerSignUpFormFields.emailEvent, categoryEvent = _useMakerSignUpFormFields.categoryEvent, setFormField = _useMakerSignUpFormFields.setFormField, returnEvent = _useMakerSignUpFormFields.returnEvent, sourceEvent = _useMakerSignUpFormFields.sourceEvent, countryEvent = _useMakerSignUpFormFields.countryEvent, secondaryCategoryOptions = _useMakerSignUpFormFields.secondaryCategoryOptions, selectedProductCategory = _useMakerSignUpFormFields.selectedProductCategory, shouldCollectSecondaryProductCategory = _useMakerSignUpFormFields.shouldCollectSecondaryProductCategory, numberStoresEvent = _useMakerSignUpFormFields.numberStoresEvent;
    var labels = getLabels(strictLocalize);
    var viewport = useViewport();
    var CompanyNameInput = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Input, {
                label: labels["brand_name"],
                error: errorFor("companyName"),
                value: companyName,
                name: "companyName",
                onChange: function(e) {
                    brandNameEvent();
                    onChange(e);
                },
                "data-test-id": "companyName",
                autoComplete: "organization"
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            })
        ]
    });
    var BusinessWebsiteInput = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Input, {
                label: labels["website_url"],
                defaultValue: url,
                onBlur: onUrlBlur,
                error: errorFor("url"),
                suffixNode: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        urlValidationInProgress ? /*#__PURE__*/ _jsx(LoadingSpinner, {
                            size: "small"
                        }) : null,
                        isUrlValid ? /*#__PURE__*/ _jsx(CheckOutline, {}) : null
                    ]
                }),
                autoComplete: "url",
                "data-test-id": "url"
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            })
        ]
    });
    var EmailAddressInput = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Input, {
                label: labels["email_address"],
                error: errorFor("email"),
                name: "email",
                value: email,
                onChange: function(e) {
                    emailEvent();
                    onChange(e);
                },
                "data-test-id": "email",
                autoComplete: "email"
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            })
        ]
    });
    var ProductCategoryDropdown = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FlexDropdown, {
                label: labels["primary_category"],
                options: INBOUND_BRAND_CATEGORY_OPTIONS(strictLocalize),
                onSelect: function(value) {
                    categoryEvent();
                    setFormField("categoryOption", value);
                    secondaryCategoryOptions.clear();
                },
                value: categoryOption === null || categoryOption === void 0 ? void 0 : categoryOption.value,
                error: errorFor("categoryOption"),
                "data-test-id": "category",
                disableInput: true
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            })
        ]
    });
    var SecondaryProductCategorySelect = shouldCollectSecondaryProductCategory ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FormInputLabel, {
                children: /*#__PURE__*/ _jsxs(WrappingRow, {
                    children: [
                        labels["secondary_category"],
                        /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "Siu0Ga",
                            defaultMessage: [
                                {
                                    type: 8,
                                    value: "NoWrapFormatting",
                                    children: [
                                        {
                                            type: 0,
                                            value: "(select all that apply)"
                                        }
                                    ]
                                }
                            ],
                            values: {
                                NoWrapFormatting: NoWrapFormatting
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsx(Grid, {
                columns: viewport.isMobile ? 1 : 2,
                gap: "2x",
                children: selectedProductCategory.subCategories.map(function(x) {
                    return /*#__PURE__*/ _jsx(Checkbox, {
                        onChange: function() {
                            var newCategories = new Set(secondaryCategoryOptions);
                            if (newCategories.has(x.value)) {
                                newCategories.delete(x.value);
                            } else {
                                newCategories.add(x.value);
                            }
                            setFormField("secondaryCategoryOptions", newCategories);
                        },
                        checked: secondaryCategoryOptions.has(x.value),
                        label: x.label
                    }, x.value);
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            })
        ]
    }) : null;
    var IndependentStoreDropdown = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FlexDropdown, {
                label: labels["number_of_stores"],
                value: stockists === null || stockists === void 0 ? void 0 : stockists.toString(),
                options: STOCKIST_IOPTIONS(strictLocalize),
                onSelect: function(option) {
                    numberStoresEvent();
                    setFormField("stockists", parseInt(option.value));
                },
                error: errorFor("stockists"),
                "data-test-id": "stockists",
                disableInput: true
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            })
        ]
    });
    var HearAboutUsDropdown = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FlexDropdown, {
                label: HEAR_ABOUT_US_LABEL(strictLocalize),
                value: displaySource,
                options: SOURCE_OPTIONS(strictLocalize),
                onSelect: function(option) {
                    sourceEvent();
                    setFormField("_source", option.value);
                },
                "data-test-id": "source",
                disableInput: true
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            })
        ]
    });
    var LocationDropdown = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "DxaDsm",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Country of tax residence"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Tooltip, {
                        contents: [
                            {
                                body: strictLocalize({
                                    id: "xWiW7d",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "This is the country in which your business is managed or incorporated, and files income tax returns."
                                        }
                                    ]
                                })
                            }
                        ],
                        icon: /*#__PURE__*/ _jsx(Information, {
                            color: Core.text.subdued,
                            width: "16px",
                            height: "16px"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Dropdown, {
                "data-test-id": "country",
                options: countryDropdownOption,
                value: countryLabel,
                onSelect: function(option) {
                    LocalStorage.get().setItem(MAKER_SIGN_UP_BASED_IN_STORAGE_KEY, option.value);
                    countryEvent();
                    setCountry({
                        isoCode: option.value,
                        displayName: option.label
                    });
                },
                error: errorFor("country.isoCode")
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            })
        ]
    });
    var NumberOfProductsDropdown = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FlexDropdown, {
                label: NUMBER_OF_PRODUCTS_LABEL(strictLocalize),
                value: numProducts === null || numProducts === void 0 ? void 0 : numProducts.toString(),
                options: NUM_PRODUCTS_IOPTIONS(strictLocalize),
                onSelect: function(option) {
                    setFormField("numProducts", parseInt(option.value));
                },
                error: errorFor("numProducts"),
                "data-test-id": "numProducts",
                disableInput: true
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            })
        ]
    });
    var renderSignupForm = function() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                CompanyNameInput,
                EmailAddressInput,
                BusinessWebsiteInput,
                LocationDropdown,
                NumberOfProductsDropdown,
                IndependentStoreDropdown,
                ProductCategoryDropdown,
                SecondaryProductCategorySelect,
                HearAboutUsDropdown
            ]
        });
    };
    var footerDesktopComponent = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(CTAButton, {
                disabled: !shouldShowSMSOptIn ? !acceptedTerms : false,
                variant: "primary",
                onClick: onSubmit,
                "data-test-id": "submit",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "n1wyH4",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Continue"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            !shouldShowSMSOptIn ? /*#__PURE__*/ _jsx(Row, {
                align: "flex-start",
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    onClick: returnEvent,
                    linkTo: brands(),
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "WC1ER4",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Return to Faire.com"
                            }
                        ]
                    })
                })
            }) : null
        ]
    });
    var renderFooterMobileComponent = function() {
        var footerButtonGroup = /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                justify: "center",
                style: {
                    padding: getSpacing("3x", 0)
                },
                children: [
                    /*#__PURE__*/ _jsx(CTAButton, {
                        variant: "secondary",
                        onClick: onBackClick,
                        "data-test-id": "back",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "YfVGXv",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Back"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsx(CTAButton, {
                        disabled: !shouldShowSMSOptIn ? !acceptedTerms : false,
                        variant: "primary",
                        onClick: onSubmit,
                        "data-test-id": "submit",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "n1wyH4",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Continue"
                                }
                            ]
                        })
                    })
                ]
            })
        });
        return /*#__PURE__*/ _jsxs(MakerSignUpFooterWrapper, {
            children: [
                /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(BareProgressBar, {
                        $progress: 0,
                        $height: "2px"
                    })
                }),
                footerButtonGroup
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(MakerSignUpWrapper, {
        children: [
            /*#__PURE__*/ _jsx(FormHeaderContentWrapper, {
                children: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "2x"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "displaySSerifRegular",
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "fhndCW",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Grow your wholesale business"
                                    }
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "2x"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "dkJw22",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Let's start with a few details"
                                    }
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(FormContentWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "2x"
                    }),
                    renderSignupForm()
                ]
            }),
            /*#__PURE__*/ _jsxs(FormContentWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "1x"
                    }),
                    !shouldShowSMSOptIn ? /*#__PURE__*/ _jsx(AcceptTermsCheckbox, {
                        hasError: false,
                        value: acceptedTerms,
                        onChange: function() {
                            return toggleAcceptedTerms();
                        }
                    }) : null,
                    errorFor("error") ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                color: Core.text.critical,
                                children: errorFor("error")
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "2x"
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsx(ResponsiveContent, {
                        desktop: footerDesktopComponent,
                        mobile: renderFooterMobileComponent()
                    }),
                    shouldShowSMSOptIn ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "1x"
                            }),
                            /*#__PURE__*/ _jsx(AcceptTermsMessage, {})
                        ]
                    }) : null
                ]
            })
        ]
    });
};
export var MakerSignUpForm = observer(MakerSignUpFormBase);
var CTAButton = styled(Button).withConfig({
    componentId: "sc-8cae823f-0"
})([
    "width:fit-content;min-width:250px;",
    "{width:42%;min-width:100px;}"
], responsiveMediaQueries.mobile);
var FlexDropdown = styled(Dropdown).attrs({
    theme: {
        input: {
            label: {
                color: Core.text.default
            }
        }
    }
}).withConfig({
    componentId: "sc-8cae823f-1"
})([
    "flex:1;"
]);
var FormContentWrapper = styled(Column).withConfig({
    componentId: "sc-8cae823f-2"
})([
    "width:100%;",
    "{background-color:",
    ";padding:0 ",
    ";}"
], responsiveMediaQueries.mobile, Core.surface.inverse, getSpacing("3x"));
var FormHeaderContentWrapper = styled(Column).withConfig({
    componentId: "sc-8cae823f-3"
})([
    "",
    "{padding:0 ",
    ";}"
], responsiveMediaQueries.mobile, getSpacing("3x"));
// eslint-disable-next-line @faire/prefer-slate-attrs -- move gap to attrs
var WrappingRow = styled(Row).withConfig({
    componentId: "sc-8cae823f-4"
})([
    "flex-flow:wrap;gap:0 4px;"
]);
